import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IArea } from '@app/models/area.interface';
import {  Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '@app/../environments/environment';
import { State, select$ } from '@app/shared/helpers/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { selectCurrentItemState } from '@app/modules/organization/store/selectors/organization.selectors';
import * as OrganizationsActions from '@app/modules/organization/store/actions/organization.actions';

@Injectable({
  providedIn: 'root'
})
export class AreasService {
  public endpoint:string = environment.apiUrl + '/areas';

  
  constructor(private http: HttpClient, private _matSnackbar:  MatSnackBar, private store$: Store) { 

  }

  public getAreas(): Observable<any>{
    return this.http.get<any>(this.endpoint);
  }
  
  public onUpdateArea(area, id){
    return this.http.put<any>(`${this.endpoint}/${id}`, area);
  }

  public onAddArea(prdAreaNameEn){
    return this.http.post<any>(`${this.endpoint}`, prdAreaNameEn);
  }

  public onDelete(){
    let id;
    this.store$.select(selectCurrentItemState).subscribe((res) => id = res.prdAreaID)
    return this.http.delete<any>(`${this.endpoint}/${id}`)
  }

  public getAreaWithProducts(){
    return this.http.get<any>(`${this.endpoint}/getAreaWithProducts`);
  }

  public onSortAreas(areas){
    this.http.patch(`${this.endpoint}/sort`,{
      areas
    }).pipe(first()).subscribe(item => {
    })
  }

  public onSortAreasByName(prdAreaID): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Content-type', 'application/json');
    return this.http.patch(`${this.endpoint}/sort/products/name/${prdAreaID}`, {
      headers
    });
  }
}
